if (!customElements.get('cart-step-indicator')) {
    customElements.define(
        'cart-step-indicator',

        class CartStepIndicator extends HTMLElement {
            constructor() {
                super();

                this.threshold = parseInt(this.getAttribute("threshold"));
                this.cartTotal = parseInt(this.getAttribute("cart-total"));
                this.pathElements = Array.from(this.querySelectorAll(".threshold-line"));
                this.numberOfPathElements = this.pathElements.length;
                this.numerOfElementsToFill = this.numberOfPathElements;

                if(this.threshold >= this.cartTotal) {
                    this.numerOfElementsToFill = Math.floor(
                        (this.cartTotal / this.threshold) * this.numberOfPathElements
                    );
                }
                
                this.runAnimation();
            }

            runAnimation() {

                let delay = 0;

                for (let i = 0; i < this.numerOfElementsToFill; i++) {
                    setTimeout(() => {
                        this.pathElements[i].style.fill = "#000";
                    }, delay);
            
                    delay += 25;
                }
            }
        }
    )
}